export const LISTING_PRODUCT_CATEGORIES="LISTING_PRODUCT_CATEGORIES"
export const LISTING_PRODUCT_CATEGORIES_SUCCESS="LISTING_PRODUCT_CATEGORIES_SUCCESS"
export const LISTING_PRODUCT_CATEGORIES_FAILED="LISTING_PRODUCT_CATEGORIES_FAILED"
export const ADDING_PRODUCT_CATEGORIES="ADDING_PRODUCT_CATEGORIES"
export const ADDING_PRODUCT_CATEGORIES_SUCCESS="ADDING_PRODUCT_CATEGORIES_SUCCESS"
export const ADDING_PRODUCT_CATEGORIES_FAILED="ADDING_PRODUCT_CATEGORIES_FAILED"
export const DELETING_PRODUCT_CATEGORIES="DELETING_PRODUCT_CATEGORIES"
export const DELETING_PRODUCT_CATEGORIES_SUCCESS="DELETING_PRODUCT_CATEGORIES_SUCCESS"
export const DELETING_PRODUCT_CATEGORIES_FAILED="DELETING_PRODUCT_CATEGORIES_FAILED"
export const UPDATING_PRODUCT_CATEGORIES="UPDATING_PRODUCT_CATEGORIES"
export const UPDATING_PRODUCT_CATEGORIES_SUCCESS="UPDATING_PRODUCT_CATEGORIES_SUCCESS"
export const UPDATING_PRODUCT_CATEGORIES_FAILED="UPDATING_PRODUCT_CATEGORIES_FAILED"
export const INFO_PRODUCT_CATEGORIES="INFO_PRODUCT_CATEGORIES"
export const INFO_PRODUCT_CATEGORIES_SUCCESS="INFO_PRODUCT_CATEGORIES_SUCCESS"
export const INFO_PRODUCT_CATEGORIES_FAILED="INFO_PRODUCT_CATEGORIES_FAILED"
export const RESET_PRODUCT_CATEGORIES_EDIT_STATE = "RESET_PRODUCT_CATEGORIES_EDIT_STATE"
export const RESET_PRODUCT_CATEGORIES_ADD_STATE = "RESET_PRODUCT_CATEGORIES_ADD_STATE"
export const RESET_PRODUCT_CATEGORIES_INFO_STATE = "RESET_PRODUCT_CATEGORIES_INFO_STATE"